import React, { useState, lazy } from "react";

import Message from "../Message";
import SuccessRes from "./SuccessRes";
import PhoneKeyField from "../../extra/PhoneKeyField";
import { addCustomerSchema } from "../../../joi/customerSchema";
import { updateCustomerSchema } from "../../../joi/customerSchema";
import { addCustomerSetData } from "../../../../context/api/cutomer/add-customer/addCustomerSetData";
import { updateCustomerSetData } from "../../../../context/api/cutomer/update-customer/updateCustomerSetData";
import { useValidator } from "react-joi";
import { useCookies } from "react-cookie";
import { joiErrorMessage } from "../../extra/joiErrorMessage";
// Bootstrap
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Modal from "react-bootstrap/Modal";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { useEffect } from "react";

const CreateCustomerModal = ({
  show,
  onHide,
  lang,
  dataTranslate,
  action,
  data,
  setRefreshData,
}) => {
  var schema =
    action === "update"
      ? updateCustomerSchema(lang).schema
      : addCustomerSchema(lang).schema;

  const initialMessageRes = {
    success: Boolean,
    message: String,
    isShow: false,
  };

  const initialSuccessMessage = {
    success: false,
    type: "",
    data: {},
  };

  const { state, setData, setExplicitField, validate, reset } =
    useValidator(schema);
  const [messageResponse, setMessageResponse] = useState(initialMessageRes);
  const [successMessage, setSuccessMessage] = useState(initialSuccessMessage);
  const [cookies] = useCookies();
  const [btnLoader, setBtnLoader] = useState(false);
  const [phoneNum, setPhoneNum] = useState("");

  useEffect(() => {
    if (
      phoneNum.startsWith("+964") &&
      phoneNum.replace(/\s/g, "").slice(4).startsWith("0")
    ) {
      setData((old) => ({
        ...old,
        phoneNumber: "964" + phoneNum.replace(/\s/g, "").slice(5),
      }));
    } else {
      setData((old) => ({
        ...old,
        phoneNumber: phoneNum.replace(/\s/g, "").slice(1),
      }));
    }
  }, [phoneNum, action]);

  const createCustomer = (e) => {
    e.preventDefault();
    let credintial = {};
    for (const item in state.$data) {
      if (state.$data[item] != null) {
        credintial[item] = state.$data[item];
      }
    }
    // remove any empty value
    for (const item in credintial) {
      if (state.$data[item] === "") {
        delete credintial[item];
      }
    }

    if (state.$all_source_errors.length < 1) {
      setBtnLoader(() => true);
      return addCustomerSetData(
        lang,
        setMessageResponse,
        cookies,
        credintial,
        setSuccessMessage,
        setBtnLoader
      );
    }
  };

  const updateCustomer = (e) => {
    e.preventDefault();
    const userId = data.id;
    let credintial = {};
    for (const item in state.$data) {
      if (state.$data[item] != null) {
        credintial[item] = state.$data[item];
      }
    }
    // remove any empty value
    for (const item in credintial) {
      if (state.$data[item] === "") {
        delete credintial[item];
      }
    }

    if (state.$all_source_errors.length < 1) {
      setBtnLoader(() => true);
      return updateCustomerSetData(
        lang,
        setMessageResponse,
        cookies,
        credintial,
        setSuccessMessage,
        setBtnLoader,
        userId
      );
    }
  };

  return (
    <>
      <Message
        messageResponse={messageResponse}
        close={() => setMessageResponse(initialMessageRes)}
        lang={lang}
      />

      <Modal
        show={show}
        onHide={onHide}
        backdrop="static"
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="forget-pass-otp-form"
        dir={lang === "AR" ? "rtl" : "ltr"}
      >
        {successMessage.success ? (
          <SuccessRes
            lang={lang}
            dataTranslate={dataTranslate}
            onHide={async () => {
              await onHide();
              setSuccessMessage(initialSuccessMessage);
              setRefreshData((prev) => prev + 1);
            }}
            res={successMessage}
          />
        ) : (
          <>
            <Modal.Header className="d-flex align-items-center justify-content-center ">
              <Modal.Title
                id="contained-modal-title-vcenter"
                className="fs-2 d-flex flex-row gap-2"
              >
                <span>
                  {action === "add"
                    ? dataTranslate.popups.add_client.add_title
                    : action === "update"
                    ? dataTranslate.popups.add_client.update_title
                    : ""}
                </span>
                {action === "update" ? (
                  <span style={{ color: "red" }}>{data.fullName}</span>
                ) : (
                  ""
                )}
              </Modal.Title>
            </Modal.Header>

            <Modal.Body className="mx-5">
              <div dir={lang === "AR" ? "rtl" : ""}>
                <Container>
                  <Row className="mb-lg-3">
                    <Col lg={6} sm={12} className="mb-3 mb-lg-0">
                      <Form.Group>
                        <Form.Label>
                          {dataTranslate.popups.add_client.client_name}
                          {action === "add" ? (
                            <span>
                              <sup style={{ color: "red" }}> *</sup>
                            </span>
                          ) : (
                            ""
                          )}
                        </Form.Label>
                        <Form.Control
                          placeholder={
                            dataTranslate.popups.add_client.client_name_p
                          }
                          defaultValue={
                            action === "update" ? data.fullName : ""
                          }
                          onChange={(e) => {
                            setData((old) => ({
                              ...old,
                              fullName: e.target.value,
                            }));
                          }}
                          onBlur={() => setExplicitField("fullName", true)}
                        />
                      </Form.Group>
                      <Form.Text style={{ color: "red" }}>
                        {joiErrorMessage(state.$errors.fullName)}
                      </Form.Text>
                    </Col>

                    <Col lg={6} sm={12} className="mb-3 mb-lg-0">
                      <Form.Group>
                        <Form.Label>
                          {dataTranslate.popups.add_client.phone_number}
                          {action === "add" ? (
                            <span>
                              <sup style={{ color: "red" }}> *</sup>
                            </span>
                          ) : (
                            ""
                          )}
                        </Form.Label>
                        <div dir="ltr" className="w-100">
                          <PhoneKeyField
                            className="w-100"
                            action={action}
                            defaultValue={
                              action === "update" ? data.phoneNumber : ""
                            }
                            setPhoneNum={setPhoneNum}
                            setExplicitField={setExplicitField}
                            phoneNum={phoneNum}
                          />
                        </div>
                      </Form.Group>
                      <Form.Text style={{ color: "red" }}>
                        {joiErrorMessage(state.$errors.phoneNumber)}
                      </Form.Text>
                    </Col>
                  </Row>

                  <Row className="mb-lg-3">
                    <Col lg={4} sm={12} className="mb-3 mb-lg-0">
                      <Form.Group>
                        <Form.Label>
                          {dataTranslate.popups.add_client.place_name}
                        </Form.Label>
                        <Form.Control
                          placeholder={
                            dataTranslate.popups.add_client.place_name
                          }
                          defaultValue={
                            action === "update" ? data.shopName : ""
                          }
                          onChange={(e) => {
                            setData((old) => ({
                              ...old,
                              shopName: e.target.value,
                            }));
                          }}
                          onBlur={() => setExplicitField("shopName", true)}
                        />
                      </Form.Group>

                      <Form.Text style={{ color: "red" }}>
                        {joiErrorMessage(state.$errors.shopName)}
                      </Form.Text>
                    </Col>

                    <Col lg={2} sm={12} className=" mb-lg-0">
                      <Form.Group>
                        <Form.Label>
                          {dataTranslate.popups.add_client.client_code}
                          {action === "add" ? (
                            <span>
                              <sup style={{ color: "red" }}> *</sup>
                            </span>
                          ) : (
                            ""
                          )}
                        </Form.Label>
                        <Form.Control
                          placeholder="TH44"
                          defaultValue={
                            action === "update" ? data.customer_code : ""
                          }
                          onChange={(e) => {
                            setData((old) => ({
                              ...old,
                              customer_code: e.target.value,
                            }));
                          }}
                          onBlur={() => setExplicitField("customer_code", true)}
                        />
                      </Form.Group>
                      <Form.Text style={{ color: "red" }}>
                        {joiErrorMessage(state.$errors.customer_code)}
                      </Form.Text>
                    </Col>

                    <Col lg={6} sm={12} className=" mb-lg-0">
                      <Form.Group>
                        <Form.Label>
                          {dataTranslate.popups.add_client.days_warning}
                        </Form.Label>
                        <Form.Control
                          type="number"
                          placeholder="15"
                          defaultValue={
                            action === "update" ? data.debtorLimit : 15
                          }
                          onChange={(e) => {
                            setData((old) => ({
                              ...old,
                              debtorLimit: parseInt(e.target.value),
                            }));
                          }}
                          onBlur={() => setExplicitField("debtorLimit", true)}
                        />
                      </Form.Group>
                      <Form.Text style={{ color: "red" }}>
                        {joiErrorMessage(state.$errors.debtorLimit)}
                      </Form.Text>
                    </Col>
                  </Row>

                  <Row className="mb-lg-3">
                    {/* <Col lg={6} sm={12} className="mb-3 mb-lg-0">
                      <Form.Group>
                        <Form.Label>
                          {dataTranslate.popups.add_client.cold_wallet_balance}
                        </Form.Label>
                        <Form.Control
                          value="0.00"
                          className="wallet-input-cold"
                          readOnly
                        />
                      </Form.Group>
                    </Col> */}

                    {/* <Col lg={6} sm={12} className="mb-3 mb-lg-0">
                      <Form.Group>
                        <Form.Label>
                          {dataTranslate.popups.add_client.hot_wallet_balance}
                        </Form.Label>
                        <Form.Control
                          value="0.00$"
                          className="wallet-input-hot"
                          readOnly
                        />
                      </Form.Group>
                    </Col> */}
                  </Row>
                </Container>
              </div>
            </Modal.Body>
            <Modal.Footer
              className="w-100 d-flex flex-row align-items-center"
              dir="ltr"
            >
              <div className="w-100 double-btns d-flex flex-row align-items-center justify-content-center gap-2">
                {action === "add" ? (
                  <Button
                    onClick={(e) => {
                      validate();
                      createCustomer(e);
                    }}
                    disabled={btnLoader ? true : false}
                  >
                    {dataTranslate.popups.add_client.add}
                  </Button>
                ) : action === "update" ? (
                  <Button
                    onClick={(e) => {
                      validate();
                      updateCustomer(e);
                    }}
                    disabled={btnLoader ? true : false}
                  >
                    {dataTranslate.popups.add_client.update}
                  </Button>
                ) : (
                  ""
                )}

                <Button
                  onClick={() => {
                    reset();
                    setPhoneNum("");
                    onHide();
                  }}
                >
                  {dataTranslate.popups.add_client.close}
                </Button>
              </div>
            </Modal.Footer>
          </>
        )}
      </Modal>
    </>
  );
};

export default CreateCustomerModal;
